import styles from "./styles.module.scss";
import {
  RegistrationStep1,
  RegistrationStep2,
  RegistrationStep3,
  RegistrationStep4,
} from "@src/features/auth";
import { Box, Typography } from "@mui/material";
import wave from "@src/shared/assets/header copy 2.png";
import logo from "@src/shared/assets/logo_1.png";
import { useEffect, useState } from "react";
import { useCreateUser, useUpdateUser } from "@src/entities/login";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { Navigate } from "react-router-dom";

//Регистрация, доделать с Кириллом

export const RegistrationPage = () => {
  const [step, setStep] = useState(1);
  const [isAllFieldsReady, setIsAllFieldsReady] = useState(false);
  const { mutate: createUser, error } = useCreateUser();
  const { isAuthenticated } = useAuthStore();
  const {
    mutate: updateUser,
    error: updateUserError,
    isSuccess: isUpdateUserSuccess,
  } = useUpdateUser();
  const updateAccessToken = useAuthStore((state) => state.updateAccessToken);
  const isUpdateAccesToken = useAuthStore((state) => state.isUpdateAccesToken);
  const setFlagUpdateToken = useAuthStore((state) => state.setFlagUpdateToken);

  const isNavigateRegistrationSuccessPage =
    isAuthenticated && isUpdateUserSuccess && !isUpdateAccesToken;

  const [data, setData] = useState({
    email: "",
    code: "",
    password: "",
    firstName: "",
    lastName: "",
    phone: "",
  });

  useEffect(() => {
    if (error) {
      alert(error.message);
    }
    if (updateUserError) {
      alert(updateUserError.message);
    }
    setIsAllFieldsReady(false);
  }, [error, updateUserError]);

  useEffect(() => {
    if (isAllFieldsReady) {
      createUser(
        {
          login: data.email,
          code: data.code,
          password: data.password,
          username: data.email,
        },
        {
          onSuccess: (response) => {
            useAuthStore.getState().setUser({
              user: response.data.user,
              tokens: {
                access_token: response.data.tokens.access,
              },
            });
            setFlagUpdateToken(true);
            updateUser(
              {
                email: data.email,
                data: {
                  first_name: data.firstName,
                  last_name: data.lastName,
                  phone: data.phone,
                  password: data.password,
                  email: data.email,
                },
              },
              {
                onSuccess: (data) => {
                  const userToken = data?.data?.tokens?.access;

                  updateAccessToken(userToken);
                },
              },
            );
          },
        },
      );
    }
  }, [isAllFieldsReady]);

  if (isNavigateRegistrationSuccessPage) {
    return <Navigate to="/registration-success" />;
  }

  return (
    <>
      <Box className={`${styles.root} montserrat-font`}>
        <img src={wave} alt="wave" className={styles.wave} />
        <div className={styles.leftPanel}>
          {step === 1 && (
            <RegistrationStep1
              setStep={setStep}
              setRegistrationData={setData}
            />
          )}
          {step === 2 && (
            <RegistrationStep2
              login={data.email}
              setStep={setStep}
              setRegistrationData={setData}
            />
          )}
          {step === 3 && (
            <RegistrationStep3
              setRegistrationData={setData}
              setStep={setStep}
            />
          )}
          {step === 4 && (
            <RegistrationStep4
              setStep={setStep}
              setIsAllFieldsReady={setIsAllFieldsReady}
              setRegistrationData={setData}
            />
          )}
        </div>
        <Box className={styles.rightPanel}>
          <img src={logo} alt="logo" className={styles.logo} />
          <Typography className={styles.slogan}>
            Помощник по найму
            <br />
            сотрудников 24/7
          </Typography>
        </Box>
      </Box>
    </>
  );
};
